/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateLoyaltyAccountRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {CreateLoyaltyAccountResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const createLoyaltyAccount = (request:CreateLoyaltyAccountRequest, options?: CashRequestOptions) => post<CreateLoyaltyAccountRequest, CreateLoyaltyAccountResponse>("/cash-app/local/loyalty/create-account", request, {...options, rejectOnError: true })